import { render } from "./TaskAssignTMS.vue?vue&type=template&id=39a01f6e"
import script from "./TaskAssignTMS.vue?vue&type=script&lang=js"
export * from "./TaskAssignTMS.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\bkp\\my-vue-pwa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__